import { render, staticRenderFns } from "./neck_massage.vue?vue&type=template&id=62967b13&scoped=true&"
import script from "./neck_massage.vue?vue&type=script&lang=js&"
export * from "./neck_massage.vue?vue&type=script&lang=js&"
import style0 from "./neck_massage.vue?vue&type=style&index=0&id=62967b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62967b13",
  null
  
)

export default component.exports